// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const USER_STROLLERS_SELECT_ENTER_SOME_CHARS = "Zadaj aspo\u0148 2 znaky z n\u00e1zvu ko\u010d\u00edka";
export const USER_STROLLERS_SELECT_NO_RESULTS = "\u017diadny v\u00fdsledok";
export const USER_STROLLERS_SELECT_SEARCHING = "Vyh\u013ead\u00e1vam";
